import { ConfiguratorConfig, ConfigurationsRegistry } from '@icc/configurator/types';
import { AccessoriesActiveConfiguration } from './accessories-active-configuration';
import { AccessoriesConfiguration } from './accessories-configuration';

export const ACCESSORY_CONFIGURATOR_CONFIG: ConfiguratorConfig = {
    type: 'accessory',
    activeConfigurationClass: AccessoriesActiveConfiguration,
    configurationClass: AccessoriesConfiguration
};

export function registerConstructionElementsConfigurations(): void {
    ConfigurationsRegistry.register(ACCESSORY_CONFIGURATOR_CONFIG);
}
